//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DropZone from './drop-zone.vue';
import {calcItemColor} from '../utils.js';

export default {
  props: [
    'task',
    'parentcolor',
  ],
  components: {
    DropZone,
  },
  computed: {
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
  },
  methods: {
  },
};
